<script lang="ts">
	import { get_recipe } from "../tastummy";

	import { useParams } from "svelte-navigator";
	import ScreenLock from "../general/ScreenLock.svelte";
	import Popup from "../general/Popup.svelte";
	import { tippy_action } from "../general/tippy";
	import List from "../icons/List.svelte";
	const params = useParams();
	let show_ingredient_list = false;

	let recipe_prom = get_recipe($params.id);
</script>

<div class="container">
	{#await recipe_prom}
		loading
	{:then recipe}
		<ScreenLock />
		<h1 class="grid-full">{recipe.data.title}</h1>
		<div class="header-photo">
			<img src={recipe.data.image} alt="recipe pic" />
		</div>
		<h2>
			Ingredients
			<div
				style="display: inline"
				use:tippy_action={{
					content: "View All Ingredients",
					// remove the popup when clicked to improve phone UX
					onShow: (i) => {
						i.setProps({ trigger: "click" });
					},
					onHide: (i) => {
						i.setProps({ trigger: "mouseenter" });
					},
				}}
				on:click={() => (show_ingredient_list = true)}
			>
				<List />
			</div>
		</h2>

		<h2>Instructions</h2>

		<Popup bind:visible={show_ingredient_list}>
			<h1>Ingredient List</h1>
			{#each recipe.data.ingredients as ing (ing.id)}
				<div class="ingredient-popup">
					{ing.raw}
				</div>
			{/each}
		</Popup>
		<div class="item">
			<div class="ingredient-container">
				<!-- get all ingredients not used in an instruction set -->
				{#each recipe.data.ingredients.filter((ing) => !recipe.data.instructions
							.map( (ins) => ins.ingredients.map((ins_inner) => ins_inner.recipe_ingredient_id) )
							.flat()
							.includes(ing.id)) as ing}
					<div>{ing.raw}</div>
				{/each}
			</div>
			<div class="instruction-container">Extra Ingredients</div>
		</div>
		<div class="border" />
		{#each recipe.data.instructions.sort((a, b) => a.step - b.step) as ins}
			<div class="item">
				<div class="ingredient-container">
					{#each recipe.data.ingredients.filter( (ing) => ins.ingredients
								.map((ins) => ins.recipe_ingredient_id)
								.includes(ing.id) ) as ing}
						<div>{ing.raw}</div>
					{/each}
				</div>
				<div class="instruction-container">
					{ins.step} -
					{ins.value}
				</div>
			</div>
			<div class="border" />
		{/each}
	{:catch error}
		could not find recipe
	{/await}
</div>

<style>
	.container {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}
	h2 {
		margin: 1rem;
	}
	.instruction-container {
		display: flex;
		flex-direction: column;
		text-align: left;
		grid-column: 2 / 4;
	}
	.ingredient-container {
		display: flex;
		flex-direction: column;
		text-align: left;
	}
	.ingredient-popup {
		margin: 1.5rem;
	}
	.item {
		padding: 2.5em;
		grid-column: 1 / 4;

		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}
	.border {
		height: 1px;
		background: radial-gradient(
			circle,
			rgba(255, 255, 255, 0.6) 10%,
			rgba(255, 255, 255, 0) 60%
		);
		grid-column: 1 / 4;
	}
	.header-photo {
		grid-column: 1 / 4;
	}
	img {
		max-width: 400px;
		max-height: 400px;
	}
	@media (max-width: 640px) {
		.instruction-container {
			grid-column: 2 / 4;
		}
		.ingredient-container {
			grid-column: 1 / 2;
		}
	}
</style>
